import script from "./ExamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamModal.vue?vue&type=script&setup=true&lang=js"

import "./ExamModal.vue?vue&type=style&index=0&id=8876fa14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8876fa14"]])

export default __exports__